import { Stack, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { formatNumber } from "../../../../../../../../common/utils";
import { HeatSteamConsumptionResultsDTO } from "../../../../../../../../datasources/api-client/data-contracts";

export const getHeatSteamRows = (data: HeatSteamConsumptionResultsDTO, t: TFunction) => {
	if (!data) return [];

	const safeNumber = (val: any): number => {
		if (val === null || val === undefined || val === "" || isNaN(Number(val))) {
			return 0;
		}
		return Number(val);
	};

	return [
		{
			id: 0,
			type: t("greenrouter/total"),
			consumption: {
				value: safeNumber(data.consumption.value.value),
				measure: "",
			},
			emissions: {
				value: safeNumber(data.co2e.value),
				percent: safeNumber(data.co2e.percentage),
			},
		},
	];
};

export const heatSteamDataCols: GridColDef[] = [
	{
		field: "type",
		headerName: "",
		flex: 1,
		sortable: false,
		renderCell: (params) => {
			const isTotal = params.row.type?.toLowerCase().includes("total");
			return (
				<Stack direction="row" alignItems="center" height="100%">
					<Typography variant="body1" fontWeight={isTotal ? 700 : 400}>
						{params.value}
					</Typography>
				</Stack>
			);
		},
	},
	{
		field: "consumption",
		headerName: "consumption",
		flex: 1,
		sortable: false,
		renderCell: (params) => {
			const { value } = params.row.consumption;
			return (
				<Stack spacing={1} height="100%" direction="row" justifyContent="center" alignItems="center">
					<Typography flex={1} textAlign={"right"} variant="body1" fontWeight={700}>
						{formatNumber(value, "decimal", 2, 2)}
					</Typography>
				</Stack>
			);
		},
	},
	{
		field: "emissions",
		headerName: "emissions",
		flex: 1,
		sortable: false,
		renderCell: (params) => {
			const { value, percent } = params.row.emissions;
			return (
				<Stack spacing={1} height="100%" direction="row" justifyContent="center" alignItems="center">
					<Typography flex={1} textAlign={"right"} variant="body1" fontWeight={700}>
						{formatNumber(value, "decimal", 2, 2)}
					</Typography>
					<Typography flex={1} variant="caption" color="text.secondary">
						({formatNumber(percent / 100, "percent", 2, 2)})
					</Typography>
				</Stack>
			);
		},
	},
];

export const getHeatSteamColumns = (dataCol: GridColDef[], t: TFunction) =>
	dataCol.map((col, index) => {
		const label = col.headerName ? t(`greenrouter/refrigerants/${col.headerName}`) : "";
		const justify = index === 0 ? "start" : index === 1 ? "end" : "center";

		return {
			...col,
			headerName: label,
			renderHeader: () => {
				if (!label) {
					return null;
				}

				return (
					<Stack direction={"column"} width={"100%"}>
						<Stack
							direction="row"
							justifyContent={justify}
							sx={{ fontWeight: "bold" }}
							spacing={1}
							alignItems="baseline"
						>
							<Typography variant="subtitle1">{label}</Typography>
							<Typography variant="body2" color="text.secondary">
								{
									// measure for Emissions col
								}
								{index === 1 && "kWh"}

								{index === 2 && "tCO2e"}
							</Typography>
						</Stack>
					</Stack>
				);
			},
		};
	});
